/* GOATED homepage — motion + interaction
   Baseline: scroll reveals, marquees (duplicated tracks), counters.
   Signature: pinned flagship stage with click-driven colorway swap + scroll chapters. */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- marquees: duplicate content so the -50% loop is seamless ---------- */
  ['offerTrack', 'slangTrack', 'pmA', 'pmB'].forEach(function (id) {
    var t = document.getElementById(id);
    if (!t) return;
    t.innerHTML += t.innerHTML;
  });

  /* ---------- hero: reveal immediately on load, never gated on scroll ---------- */
  requestAnimationFrame(function () {
    document.querySelectorAll('.hero .rv, .offerbar .rv').forEach(function (el, i) {
      el.style.transitionDelay = (0.06 * i) + 's';
      el.classList.add('is-in');
    });
  });

  /* ---------- scroll reveals ---------- */
  var revealTargets = document.querySelectorAll('.rv, .rv-stagger');
  if (reduce || !('IntersectionObserver' in window)) {
    revealTargets.forEach(function (el) { el.classList.add('is-in'); });
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    revealTargets.forEach(function (el) { io.observe(el); });
  }

  /* ---------- odometer counters ---------- */
  function fmt(n, format) {
    if (format === 'k') return (n / 1000).toFixed(1) + 'K';
    return n.toLocaleString('en-US') + '+';
  }
  var counters = document.querySelectorAll('[data-count]');
  if (reduce || !('IntersectionObserver' in window)) {
    // leave the static markup as-is
  } else {
    var cio = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target, target = parseFloat(el.dataset.count), format = el.dataset.format;
        var start = performance.now(), dur = 1300;
        function step(now) {
          var p = Math.min(1, (now - start) / dur);
          var eased = 1 - Math.pow(1 - p, 3);
          el.textContent = fmt(Math.round(target * eased), format);
          if (p < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
        cio.unobserve(el);
      });
    }, { threshold: 0.6 });
    counters.forEach(function (el) { cio.observe(el); });
  }

  /* ---------- signature moment: flagship colorway swap ---------- */
  var VARIANTS = {
    black: { name: 'Midnight Black', handle: 'goated-sculpt-set-midnight-black', bg: '#0e0e11', badge: '#1 Bestseller · 884+ sold' },
    grey:  { name: 'Shadow Grey',    handle: 'goated-sculpt-set-shadow-grey',    bg: '#1a1c1f', badge: '#2 Bestseller · in every size' },
    blush: { name: 'Blush Pink',     handle: 'goated-sculpt-set-blush-pink',     bg: '#241b1e', badge: '#3 Bestseller · XS sold out' },
    rose:  { name: 'Rose Pink',      handle: 'goated-sculpt-set-rose-pink',      bg: '#2a1a1e', badge: '#4 Bestseller · L sold out' }
  };
  var stage = document.getElementById('flagStage');
  var swatches = document.querySelectorAll('.sw');
  var flagName = document.getElementById('flagName');
  var flagBuy = document.getElementById('flagBuy');
  var flagBadge = document.getElementById('flagBadge');

  function setVariant(key) {
    var v = VARIANTS[key];
    if (!v || !stage) return;
    stage.querySelectorAll('img').forEach(function (img) {
      img.classList.toggle('is-on', img.dataset.v === key);
    });
    stage.style.background = v.bg;
    swatches.forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.v === key)); });
    if (flagName) flagName.textContent = v.name;
    if (flagBadge) flagBadge.textContent = v.badge;
    if (flagBuy) {
      flagBuy.href = '/products/' + v.handle;
      flagBuy.querySelector('span').textContent = 'Shop ' + v.name;
    }
  }
  swatches.forEach(function (b) {
    b.addEventListener('click', function () { setVariant(b.dataset.v); });
  });

  /* ---------- flagship scroll chapters ---------- */
  var chapters = document.querySelectorAll('.chapter');
  if (chapters.length && !reduce && 'IntersectionObserver' in window) {
    var chio = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          chapters.forEach(function (c) { c.classList.remove('is-active'); });
          e.target.classList.add('is-active');
        }
      });
    }, { threshold: 0.55 });
    chapters.forEach(function (c) { chio.observe(c); });
  }


  /* ---------- hide sticky CTA over the footer so it never covers links ---------- */
  var sticky = document.querySelector('.sticky-cta');
  var footer = document.querySelector('footer, .footer');
  if (sticky && footer && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        sticky.style.transform = e.isIntersecting ? 'translateY(110%)' : 'translateY(0)';
        sticky.style.transition = 'transform .32s ease';
      });
    }, { threshold: 0.35 }).observe(footer);
  }
})();
